<template>
    <div
        ref="pdf-scroll-page"
        v-visible="handlePageVisible"
        :class="['pdf-scroll-page', `pdf-scroll-page__pageno--${pageNumber}`, { 'is-in-view': inScrollView }]"
        :style="elementStyle"
        ondragstart='return false;'
        @drop="handleDrop($event,'COMMON')"
        @dragover="handleDragOver"
        @dragleave="onDragLeave($event, pageNumber, actualWidth, actualHeight, bottom)"
    >
        <pdf-page-render
            v-show="inScrollView"
            v-bind="{
                viewport,
                page,
                scale,
                watermarkText,
                elementStyle,
                inScrollView,
                isScrolling,
                isImage
            }"
        />

        <template v-if="inScrollView">

            <!-- slot -->
            <slot v-bind="{ pageNumber, scale, actualWidth, actualHeight, bottom, currentPage }"></slot>

            <!-- 骑缝章区域 -->
            <pdf-across-section
                v-bind="{ showAcrossSection, dragInfo }"
                @drop.stop="handleDrop($event, 'ACROSS')"
            ></pdf-across-section>

            <span class="page-number-content">{{ pageNumber }}</span>
        </template>
    </div>
</template>

<script>
import visible from '../directives/visible';
import { CSS_DIP } from '../utils/base';
import PdfPageRender from './pdf-page-render/index.vue';
import PdfAcrossSection from './pdf-across-section.vue'

export default {
    name: 'PdfScrollPage',
    components: { PdfPageRender, PdfAcrossSection },
    props: {
        page: Object,
        scrollTop: Number,
        clientHeight: Number,
        currentPage: Number,
        scale: Number,
        isScrolling: Boolean,
        isImage: Boolean,
        dragInfo: Object,
        watermarkText: String,
    },
    data () {
        return {
            offsetHeight: 0,
            offsetTop: 0,
            clientWidth: 0,
            showAcrossSection: false,
            // 是否在可视区域内
            inScrollView: false
        };
    },
    inject: ['updateCurrentPage', 'onDrop', 'onDragOver', 'onDragLeave'],
    directives: {
        visible
    },
    mounted () {
        this.updateElementBounds();
    },
    computed: {
        pageNumber () {
            return this.page.pageNumber || 0;
        },
        // 是否聚焦当前页
        isFocus () {
            const {
                offsetTop,
                bottom,
                offsetHeight,
                scrollTop,
                clientHeight
            } = this;
            if (!offsetHeight) return;
            const halfHeight = offsetHeight / 2;
            const halfScreen = clientHeight / 2;
            const delta = offsetHeight >= halfScreen ? halfScreen : halfHeight;
            const threshold = scrollTop + delta;
            return offsetTop < threshold && bottom >= threshold;
        },

        bottom () {
            return this.offsetTop + this.offsetHeight;
        },
        // 页面viewport
        viewport () {
            return this.page.getViewport({ scale: CSS_DIP * this.scale });
        },
        // 元素样式
        elementStyle () {
            let { height, width } = this.viewport;
            return {
                height: `${Math.ceil(height)}px`,
                width: `${Math.ceil(width)}px`
            };
        },
        // 当前页面真实宽度
        actualWidth () {
            let { width } = this.viewport;
            return Math.ceil(width);
        },
        // 当前页码真实高度
        actualHeight () {
            return Math.ceil(this.viewport.height);
        },
        // 当前页面相对底部的距离
        scrollBottom () {
            return this.scrollTop + this.clientHeight;
        }
    },
    watch: {
        isFocus (nv) {
            nv && this.updateCurrentPage(this.pageNumber);
        },
        scale: 'updateElementBounds'
    },
    methods: {
        /** 更新元素高度 */
        updateElementBounds () {
            this.$nextTick(() => {
                const { offsetTop = 0, offsetHeight = 0, clientWidth = 0 } =
                    this.$el || {};
                this.offsetTop = offsetTop;
                this.offsetHeight = offsetHeight;
                this.clientWidth = clientWidth;
            });
        },

        handlePageVisible (inScrollView) {
            this.inScrollView = inScrollView;
        },

        handleDragOver (event) {
            event.preventDefault();
            this.showAcrossSection = true;
            this.onDragOver(
                event,
                this.pageNumber,
                this.actualWidth,
                this.actualHeight,
                this.bottom
            );
        },

        handleDrop (event, type) {
            this.showAcrossSection = false;
            this.onDrop(
                event,
                this.pageNumber,
                this.actualWidth,
                this.actualHeight,
                this.bottom,
                type
            );
        }
    }
};
</script>

<style lang="less" scoped>
.pdf-scroll-page {
    margin: 0 auto 24px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;
    position: relative;
    background: #fff;
    visibility: hidden;

    &.is-in-view {
        visibility: visible;
    }

    &:before {
        content: '';
        display: block;
        border-bottom: 20px solid #e5e7ea;
        border-right: 20px solid #e5e7ea;
        border-left: 20px solid transparent;
        border-top: 20px solid transparent;
        position: absolute;
        bottom: -1px;
        right: -1px;
        z-index: 1;
    }

    .page-number-content {
        position: absolute;
        bottom: 2px;
        right: 6px;
        z-index: 1;
        color: #fff;
        user-select: none;
        font-size: 12px;
    }
}
</style>
